import {
  actions as appSettingsActions,
  leftPanelTabs,
} from 'apps/builder/store/reducers/settings/appSettings'

export const {
  selectEntry,
  selectScreen,
  selectSheet,
  toggleFullScreenWorkspace,
  toggleLeftPanel,
  togglePanel,
  setActiveLeftPanelTab,
  updateFlashMessage,
  toggleModal,
  sortUsers,
  sortGroups,
  updateUnsavedChanges,
  resetWorkspaceFocus,
} = appSettingsActions

export const closeModal = toggleModal({
  activeModal: '',
})

export const openPublishModal = toggleModal({
  activeModal: 'publish',
  activeEntry: '',
  activeSheet: '',
  activeLeftPanelTab: leftPanelTabs.LIBRARY,
})

export const openScreenSettings = (activeSheet, depth) => {
  return toggleModal({
    activeModal: 'screenSettings',
    activeEntry: '',
    activeSheet,
    activeSheetDepth: depth,
  })
}

export const openFieldSettings = (activeEntry, activeSheet) => {
  return toggleModal({
    activeModal: 'fieldSettings',
    activeEntry,
    activeSheet,
  })
}

export const openConvertModal = activeSheet => {
  return toggleModal({
    activeModal: 'convert',
    activeSheet,
  })
}

export const openNavigateToBuilder2 = toggleModal({
  activeModal: 'navigateToBuilder2',
  activeEntry: '',
  activeSheet: '',
  activeLeftPanelTab: leftPanelTabs.LIBRARY,
})
